import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16fe2a80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container-fluid",
  id: "itenary-div",
  style: {"height":"100% !important"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-12",
    id: "top-margin"
  })
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1))
const _hoisted_5 = {
  class: "ml-5",
  id: "breadcrums-info"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1))
const _hoisted_7 = {
  class: "row",
  style: {"padding-top":"20px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1))
const _hoisted_9 = {
  class: "col-sm-7",
  id: "info-panel"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "row town-explore-row",
  style: {"margin-top":"30%"}
}
const _hoisted_12 = { class: "col-sm-12" }
const _hoisted_13 = {
  class: "row",
  id: "topics-info"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-8" }, null, -1))
const _hoisted_15 = { class: "col-12 col-sm-3 town-explore-col" }
const _hoisted_16 = { class: "town-explore-card" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "town-explore-title" }, "Explore in this area", -1))
const _hoisted_18 = { class: "town-explore-triggers" }
const _hoisted_19 = { class: "d-flex position-relative town-explore-item" }
const _hoisted_20 = ["aria-expanded"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "town-explore-icon" }, "🎉", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "town-explore-label" }, "Festivals", -1))
const _hoisted_23 = { class: "town-dropdown" }
const _hoisted_24 = {
  key: 0,
  class: "town-dropdown-empty"
}
const _hoisted_25 = { class: "d-flex position-relative town-explore-item" }
const _hoisted_26 = ["aria-expanded"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "town-explore-icon" }, "📰", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "town-explore-label" }, "News", -1))
const _hoisted_29 = { class: "town-dropdown" }
const _hoisted_30 = {
  key: 0,
  class: "town-dropdown-empty"
}
const _hoisted_31 = { class: "d-flex position-relative town-explore-item" }
const _hoisted_32 = ["aria-expanded"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "town-explore-icon" }, "📅", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "town-explore-label" }, "Events", -1))
const _hoisted_35 = { class: "town-dropdown" }
const _hoisted_36 = {
  key: 0,
  class: "town-dropdown-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fis_header = _resolveComponent("fis-header")!
  const _component_bread_crumbs = _resolveComponent("bread-crumbs")!
  const _component_sponsors_page = _resolveComponent("sponsors-page")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fis_footer = _resolveComponent("fis-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { style: {"overflow":"auto"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_fis_header),
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_bread_crumbs, { crumbs: _ctx.breadCrumbs }, null, 8, ["crumbs"])
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", { innerHTML: _ctx.pageContent }, null, 8, _hoisted_10)
            ]),
            _createVNode(_component_sponsors_page, {
              "total-sponsors": 6,
              class: "mt-n1"
            })
          ]),
          (_ctx.loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["town-explore-btn", { 'town-explore-btn-open': _ctx.isFestivalOpen }]),
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.festivalMenu && _ctx.festivalMenu(...args))),
                              "aria-haspopup": "true",
                              "aria-expanded": _ctx.isFestivalOpen
                            }, [
                              _hoisted_21,
                              _hoisted_22,
                              _createElementVNode("span", {
                                class: _normalizeClass(["submenu-plus", { 'submenu-plus-open': _ctx.isFestivalOpen }])
                              }, "+", 2)
                            ], 10, _hoisted_20),
                            _createElementVNode("div", {
                              class: _normalizeClass(["town-dropdown-wrap", { show: _ctx.isFestivalOpen }])
                            }, [
                              _createElementVNode("ul", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.festivals, (festival, index) => {
                                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                                    _createVNode(_component_router_link, {
                                      to: _ctx.pageRouteLink(festival.link),
                                      class: "town-dropdown-link",
                                      "active-class": "active-submenu"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(festival.page_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128)),
                                (!_ctx.festivals.length)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_24, "No festivals listed yet."))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["town-explore-btn", { 'town-explore-btn-open': _ctx.isNewsOpen }]),
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.newsMenu && _ctx.newsMenu(...args))),
                              "aria-haspopup": "true",
                              "aria-expanded": _ctx.isNewsOpen
                            }, [
                              _hoisted_27,
                              _hoisted_28,
                              _createElementVNode("span", {
                                class: _normalizeClass(["submenu-plus", { 'submenu-plus-open': _ctx.isNewsOpen }])
                              }, "+", 2)
                            ], 10, _hoisted_26),
                            _createElementVNode("div", {
                              class: _normalizeClass(["town-dropdown-wrap", { show: _ctx.isNewsOpen }])
                            }, [
                              _createElementVNode("ul", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.news, (nw, index) => {
                                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                                    _createVNode(_component_router_link, {
                                      to: _ctx.pageRouteLink(nw.link),
                                      class: "town-dropdown-link",
                                      "active-class": "active-submenu"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(nw.page_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128)),
                                (!_ctx.news.length)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_30, "No news listed yet."))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["town-explore-btn", { 'town-explore-btn-open': _ctx.isEventOpen }]),
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.eventMenu && _ctx.eventMenu(...args))),
                              "aria-haspopup": "true",
                              "aria-expanded": _ctx.isEventOpen
                            }, [
                              _hoisted_33,
                              _hoisted_34,
                              _createElementVNode("span", {
                                class: _normalizeClass(["submenu-plus", { 'submenu-plus-open': _ctx.isEventOpen }])
                              }, "+", 2)
                            ], 10, _hoisted_32),
                            _createElementVNode("div", {
                              class: _normalizeClass(["town-dropdown-wrap", { show: _ctx.isEventOpen }])
                            }, [
                              _createElementVNode("ul", _hoisted_35, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, index) => {
                                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                                    _createVNode(_component_router_link, {
                                      to: _ctx.pageRouteLink(event.link),
                                      class: "town-dropdown-link",
                                      "active-class": "active-submenu"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(event.page_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128)),
                                (!_ctx.events.length)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_36, "No events listed yet."))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_fis_footer)
      ])
    ]),
    _: 1
  }))
}